var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-3" },
    [
      _c(
        "pui-collapsible",
        {
          staticClass: "msp-unit-overview",
          attrs: { configurable: "" },
          on: { toggle: _vm.handleCollapsibleToggle },
        },
        [
          _c(
            "div",
            { attrs: { slot: "collapsibleHeader" }, slot: "collapsibleHeader" },
            [_vm._v(" " + _vm._s(_vm.unit.businessAbbreviation) + " ")]
          ),
          _c(
            "div",
            {
              attrs: { slot: "collapsibleConfigurationContent" },
              slot: "collapsibleConfigurationContent",
            },
            [_c("warning-details", { attrs: { unit: _vm.unit } })],
            1
          ),
          _c(
            "div",
            { staticClass: "msp-unit-overview__wrapper" },
            [
              !_vm.isLoaded
                ? _c("pui-loader", {
                    key: _vm.unit.sid,
                    attrs: {
                      "use-vuex": true,
                      global: false,
                      "vuex-module-name": _vm.MODULE_NAME + _vm.unit.sid,
                      mode: "inline",
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLoaded,
                      expression: "isLoaded",
                    },
                  ],
                  ref: _vm.UNIT_OVERVIEW_REF + _vm.unit.sid,
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "msp-unit-overview__wrapper__content-wrapper",
                    },
                    [
                      _vm.$puiBreakpoint !== "s"
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "msp-unit-overview__wrapper__content-wrapper__item",
                              },
                              [
                                _c("time-to-maintenance", {
                                  attrs: { unit: _vm.unit },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "msp-unit-overview__wrapper__content-wrapper__item",
                              },
                              [
                                _c("next-outage", {
                                  attrs: { unit: _vm.unit },
                                  on: {
                                    mspNextOutageLoaded:
                                      _vm.handleComponentLoaded,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "msp-unit-overview__wrapper__content-wrapper__budgets-wrapper",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "msp-unit-overview__wrapper__content-wrapper__budgets-wrapper__row",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "msp-unit-overview__wrapper__content-wrapper__budgets-wrapper__row__item",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "msp-unit-overview__budget-title",
                                          },
                                          [
                                            _c(
                                              "pui-headline",
                                              { attrs: { type: "h4" } },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("budget")) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    !_vm.screenSizeLarge
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "msp-unit-overview__wrapper__content-wrapper__budgets-wrapper__row__item",
                                          },
                                          [
                                            _c("pui-link", {
                                              staticClass:
                                                "msp-unit-overview__wrapper__content-wrapper__budgets-wrapper__row__item__show-as",
                                              attrs: { title: _vm.showAsTitle },
                                              on: {
                                                click: _vm.toggleShowAsTable,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "msp-unit-overview__wrapper__content-wrapper__budgets-wrapper__row",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              !_vm.idState.showAsTable ||
                                              _vm.screenSizeLarge,
                                            expression:
                                              "!idState.showAsTable || screenSizeLarge",
                                          },
                                        ],
                                        staticClass:
                                          "msp-unit-overview__wrapper__content-wrapper__budgets-wrapper__row__item",
                                      },
                                      [
                                        _c("planned-calculated-budget", {
                                          attrs: { unit: _vm.unit },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              !_vm.idState.showAsTable ||
                                              _vm.screenSizeLarge,
                                            expression:
                                              "!idState.showAsTable || screenSizeLarge",
                                          },
                                        ],
                                        staticClass:
                                          "msp-unit-overview__wrapper__content-wrapper__budgets-wrapper__row__item",
                                      },
                                      [
                                        _c("budget-deviation", {
                                          attrs: { unit: _vm.unit },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.idState.showAsTable ||
                                              _vm.screenSizeLarge,
                                            expression:
                                              "idState.showAsTable || screenSizeLarge",
                                          },
                                        ],
                                        staticClass:
                                          "msp-unit-overview__wrapper__content-wrapper__budgets-wrapper__row__item msp-unit-overview__wrapper__content-wrapper__budgets-wrapper__row__item--table-view",
                                      },
                                      [
                                        _c("table-view", {
                                          attrs: { unit: _vm.unit },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : [
                            _c(
                              "pui-carousel",
                              { attrs: { "show-navigation": false } },
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "items" }, slot: "items" },
                                  [
                                    _c("time-to-maintenance", {
                                      attrs: { unit: _vm.unit },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { attrs: { slot: "items" }, slot: "items" },
                                  [
                                    _c("next-outage", {
                                      attrs: { unit: _vm.unit },
                                      on: {
                                        mspNextOutageLoaded:
                                          _vm.handleComponentLoaded,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { attrs: { slot: "items" }, slot: "items" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "msp-unit-overview__budget-title",
                                      },
                                      [
                                        _c(
                                          "pui-headline",
                                          { attrs: { type: "h4" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("budget")) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("planned-calculated-budget", {
                                      attrs: { unit: _vm.unit },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { attrs: { slot: "items" }, slot: "items" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "msp-unit-overview__budget-title",
                                      },
                                      [
                                        _c(
                                          "pui-headline",
                                          { attrs: { type: "h4" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("budget")) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("budget-deviation", {
                                      attrs: { unit: _vm.unit },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }